export default "__VITE_ASSET__BzdHmvk___"